export default "__VITE_ASSET__C8YhPvYQ__"